import { getCurrentCashRegister } from "@/utils/functions/getCurrentCashRegister"
import { Button } from "@okeys/shared-react-components"
import { CashRegisterTable, StripeTerminalReader } from "@okeys/shared-utils"
import { AuthUser } from "aws-amplify/auth"
import { Plus, Terminal } from "lucide-react"
import { CardDescription, CardHeader, CardTitle } from "../ui/card"

export type HeaderType =
  | "disconnectedWithCashRegister"
  | "disconnectedWithoutCashRegister"
  | "Connected"

type HeaderCashRegisterProps = {
  type: HeaderType
  readers: StripeTerminalReader[]
  currentUser: AuthUser
  cashRegisters: CashRegisterTable[]
  onOpenAddTerminalModal?: () => void
}

export const HeaderCashRegister = ({
  type,
  onOpenAddTerminalModal,
  readers,
  currentUser,
  cashRegisters,
}: HeaderCashRegisterProps) => {
  // Récupérer la caisse courante de l'utilisateur
  const currentCashRegister = getCurrentCashRegister(currentUser, cashRegisters)

  const reader = readers.find(
    (reader) => reader.id === currentCashRegister?.readerId
  )

  const handleOpenAddTerminalModal = () => {
    if (onOpenAddTerminalModal) {
      onOpenAddTerminalModal()
    }
  }

  switch (type) {
    case "disconnectedWithCashRegister":
      return (
        <CardHeader className="px-0">
          <div className="flex flex-col space-y-4 sm:flex-row sm:items-center sm:justify-between sm:space-y-0">
            <div>
              <CardTitle className="flex items-center">
                Liste des caisses enregistreuses ({cashRegisters?.length || 0})
              </CardTitle>
              <CardDescription>
                Connectez-vous à une caisse disponible pour commencer les
                encaissements
              </CardDescription>
            </div>
          </div>
        </CardHeader>
      )
    case "disconnectedWithoutCashRegister":
      return (
        <CardHeader className="text-center px-0">
          <div className="mx-auto w-16 h-16 bg-indigo-100 dark:bg-indigo-900/30 rounded-full flex items-center justify-center mb-4">
            <Terminal className="h-8 w-8 text-indigo-600 dark:text-indigo-400" />
          </div>
          <CardTitle className="text-xl">Aucune caisse enregistreuse</CardTitle>
          <p className="text-sm text-gray-600 dark:text-gray-400">
            Vous devez d'abord créer une caisse enregistreuse pour commencer les
            encaissements.
          </p>
        </CardHeader>
      )
    case "Connected":
      return (
        <div className="flex flex-row justify-between items-center mb-2">
          <p className="text-md text-gray-600 dark:text-gray-400 flex flex-col">
            Caisse active :{" "}
            {currentCashRegister?.name ||
              `Caisse ${currentCashRegister?.caisseId.slice(0, 8)}`}
            {currentCashRegister?.readerId && (
              <span
                className={`inline-flex items-center gap-1 ${
                  reader?.status === "online"
                    ? "text-green-600 dark:text-green-400"
                    : "text-red-600 dark:text-red-400"
                }`}
              >
                <Terminal className="h-3 w-3" />
                Terminal{" "}
                {reader?.status === "online" ? "connecté" : "déconnecté"} ({" "}
                {reader?.label} )
              </span>
            )}
          </p>
          <div className="flex flex-row justify-end items-end gap-2">
            {currentCashRegister?.readerId === "" && (
              <Button
                onClick={handleOpenAddTerminalModal}
                // disabled={unlockCashRegisterMutation.isPending}
              >
                <Plus className="h-4 w-4" />
                Ajouter un terminal
              </Button>
            )}
          </div>
        </div>
      )
    default:
      return null
  }
}
